import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  height: "22",
  viewBox: "0 0 30 22",
  width: "30",
  preserveAspectRatio: "xMidYMid meet"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "white" }, [
      _createElementVNode("rect", {
        width: "30",
        height: "2",
        rx: "1"
      }),
      _createElementVNode("rect", {
        y: "10",
        width: "30",
        height: "2",
        rx: "1"
      }),
      _createElementVNode("rect", {
        y: "20",
        width: "30",
        height: "2",
        rx: "1"
      })
    ], -1)
  ])))
}
export default { render: render }